import React from "react";
import html2pdf from "html2pdf.js";
const PurchaseOrderPrintDrawer = ({
  poId,
  poData,
  traceData,
  onClose
}) => {

  const generatePDF = () => {
  const element =
    document.querySelector(".po-print-area");

  if (!element) {
    alert("Print area not found");
    return;
  }

  const options = {
    margin: [3, 3, 3, 3],
    filename:
      `${poData?.po_no || "Purchase_Order"}.pdf`,
    image: {
      type: "jpeg",
      quality: 0.98
    },
    html2canvas: {
      scale: 3,
      useCORS: true
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "landscape"
    },
    pagebreak: {
      mode: ["css", "legacy"]
    }
  };

  html2pdf()
    .set(options)
    .from(element)
    .save();
};

  const cardStyle = {
  background: "#ffffff",
  border: "1px solid #dbeafe",
  borderRadius: "16px",
  padding: "18px",
  marginBottom: "20px",
  boxShadow: "0 2px 8px rgba(15,23,42,0.05)"
};

  const sectionTitle = {
  fontSize: "16px",
  fontWeight: 600,
  color: "#1d4ed8",
   marginBottom: "14px"
  //marginBottom: "18px",
  //paddingBottom: "12px",
  //borderBottom: "2px solid #dbeafe",
  //letterSpacing: "0.3px"
};

  
const formatDate = (value) => {

  if (!value) return "-";

  return new Date(value).toLocaleDateString(
    "en-IN",
    {
      day: "2-digit",
      month: "short",
      year: "numeric"
    }
  );

};

const formatAmount = value => {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "0.00";
    }

    return Number(value)
      .toLocaleString(
        "en-IN",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      );

  };

  const numberToWords = (amount) => {
  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0
  });

  const words = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen",
    "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];

  const convertBelowThousand = (num) => {
    let str = "";

    if (num >= 100) {
      str += words[Math.floor(num / 100)] + " Hundred ";
      num %= 100;
    }

    if (num >= 20) {
      str += tens[Math.floor(num / 10)] + " ";
      num %= 10;
    }

    if (num > 0) {
      str += words[num] + " ";
    }

    return str.trim();
  };

  const convert = (num) => {
    if (num === 0) return "Zero";

    const crore = Math.floor(num / 10000000);
    num %= 10000000;

    const lakh = Math.floor(num / 100000);
    num %= 100000;

    const thousand = Math.floor(num / 1000);
    num %= 1000;

    const remainder = num;

    let result = "";

    if (crore)
      result += convertBelowThousand(crore) + " Crore ";

    if (lakh)
      result += convertBelowThousand(lakh) + " Lakh ";

    if (thousand)
      result += convertBelowThousand(thousand) + " Thousand ";

    if (remainder)
      result += convertBelowThousand(remainder);

    return result.trim();
  };

  return `Rupees ${convert(
    Math.round(amount)
  )} Only`;
};

  const vendorAddress =
  poData?.vendor_detail?.addresses?.find(
    a => a.is_default
  ) || poData?.vendor_detail?.addresses?.[0];

  const vendorContact =
  poData?.vendor_detail?.contacts?.find(
    c => c.is_default
  ) || poData?.vendor_detail?.contacts?.[0];

  const vendorTax =
    poData?.vendor_detail?.taxes?.[0];
  
  // Vendor-facing PO:
// Only COMPANY-paid charges should be printed.

const printableCharges =
  (poData?.charges || []).filter(
    charge =>
      (charge.payer_type || "")
        .toUpperCase() === "COMPANY"
  );
const printableChargeAmount =
  printableCharges.reduce(
    (sum, charge) =>
      sum +
      Number(charge.charge_amount || 0),
    0
  );

const printableChargeGST =
  printableCharges.reduce(
    (sum, charge) =>
      sum +
      Number(charge.gst_amount || 0),
    0
  );
const printableTaxAmount =
  Number(
    poData?.material_gst_amount || 0
  ) +
  printableChargeGST;

const printableNetAmount =
  Number(
    poData?.material_taxable_amount || 0
  ) +
  Number(
    poData?.material_gst_amount || 0
  ) +
  printableChargeAmount +
  printableChargeGST;

const printableAmountInWords =
  numberToWords(printableNetAmount);

const printStyles = `
@media print {

  body * {
    visibility: hidden;
  }

  .po-print-area,
  .po-print-area * {
    visibility: visible;
  }

  .po-print-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background: white;
  }

  .print-hide {
    display: none !important;
  }

  table {
    page-break-inside: avoid;
  }

  .print-card {
    box-shadow: none !important;
    border: 1px solid #ddd !important;
  }
}
`;  
  console.log(
  "PO LINE",
  poData?.lines?.[0]
);

console.log("PO DATA", poData);
console.log("AMOUNT WORDS", poData?.amount_in_words);

const cgstTotal =
  (poData?.lines || []).reduce(
    (sum, line) =>
      sum + Number(line.cgst_amount || 0),
    0
  ) +
  printableCharges.reduce(
    (sum, charge) =>
      sum + Number(charge.cgst_amount || 0),
    0
  );

const sgstTotal =
  (poData?.lines || []).reduce(
    (sum, line) =>
      sum + Number(line.sgst_amount || 0),
    0
  ) +
  printableCharges.reduce(
    (sum, charge) =>
      sum + Number(charge.sgst_amount || 0),
    0
  );

const igstTotal =
  (poData?.lines || []).reduce(
    (sum, line) =>
      sum + Number(line.igst_amount || 0),
    0
  ) +
  printableCharges.reduce(
    (sum, charge) =>
      sum + Number(charge.igst_amount || 0),
    0
  );
  console.log("PO DATA", poData);
  console.log("CGST Total", cgstTotal);
console.log("SGST Total", sgstTotal);
console.log("IGST Total", igstTotal);
console.log("Tax Amount", poData?.tax_amount);
console.log("Charges", poData?.charges);

return (
    <>
     <style>
      {printStyles}
    </style>
      {/* BACKDROP */}

      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 99998
        }}
        onClick={onClose}
      />

      {/* DRAWER */}

      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
          background: "#f8fafc",
          zIndex: 99999,
          overflowY: "auto"
        }}
      >

        {/* TOOLBAR */}

        <div
          className="print-hide"
          style={{
            background: "#ffffff",
            borderBottom:
              "1px solid #e2e8f0",
            padding: "14px 20px",
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            position: "sticky",
            top: 0,
            zIndex: 100
          }}
        >

          <h4
            style={{
              margin: 0
            }}
          >
            Purchase Order Print Preview
          </h4>

          <div>

            <button
              className="btn btn-primary me-2"
              onClick={() =>
                window.print()
              }
            >
              Print
            </button>

            <button
              className="btn btn-danger me-2"
              onClick={generatePDF}
            >
              PDF
            </button>

            <button
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>

          </div>

        </div>

        <div
  className="po-print-area"
  style={{
    maxWidth: "1200px",
            margin: "20px auto",
            padding: "0 20px"
          }}
        >

          {/* COMPANY HEADER */}

          <div
            style={{
                background: "#ffffff",
                border: "1px solid #dbeafe",
                borderTop: "4px solid #2563eb",
                borderRadius: "16px",
                padding: "20px",
                marginBottom: "25px"
            }}
            >

            <div
              style={{
                display: "flex",
                justifyContent:
                  "space-between",
                alignItems: "center"
              }}
            >

              <div
                style={{
                  width: 70,
                  height: 70,
                  border:
                    "1px solid #dbeafe",
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600
                }}
              >
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#64748b"
                    }}
                    >
                    Company
                    <br />
                    Logo
                    </div>
              </div>

              <div
                style={{
                  textAlign: "right"
                }}
              >

                <h2
                style={{
                    margin: 0,
                    color: "#1e293b",
                    fontWeight: 700,
                    marginBottom: "6px"
                }}
                >
                  {poData?.company?.company_name}
                </h2>

                <div
                    style={{
                        color: "#475569",
                        maxWidth: "550px"
                    }}
                    >
                    {poData?.company?.address}
                    </div>

                    <div
                    style={{
                        marginTop: "6px",
                        color: "#334155"
                    }}
                    >
                    <strong>GSTIN :</strong>{" "}
                    {poData?.company?.gst_no || "-"}
                    </div>

                    <div
                    style={{
                        color: "#334155"
                    }}
                    >
                    <strong>PAN :</strong>{" "}
                    {poData?.company?.pan_no || "-"}
                    </div>

                    <div
                    style={{
                        color: "#334155"
                    }}
                    >
                    <strong>Email :</strong>{" "}
                    {poData?.company?.contact_email || "-"}
                    </div>

                    <div
                    style={{
                        color: "#334155"
                    }}
                    >
                    <strong>Mobile :</strong>{" "}
                    {poData?.company?.contact_mobile || "-"}
                    </div>

              </div>

            </div>

          </div>

          {/* DOCUMENT TITLE */}

          <div
            style={{
                display: "grid",
                gridTemplateColumns: "220px 1fr 260px",
                gap: "15px",
                marginBottom: "25px",
                alignItems: "center"
            }}
            >

            {/* STATUS */}

            <div
                style={{
                background: "#f8fafc",
                border: "1px solid #dbeafe",
                borderRadius: "12px",
                padding: "12px"
                }}
            >

                <div
                style={{
                    fontSize: "11px",
                    color: "#64748b",
                    textTransform: "uppercase"
                }}
                >
                Status
                </div>

                <div
                style={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: "#2563eb"
                }}
                >
                {poData?.status_name}
                </div>

            </div>

            {/* TITLE */}

            <div
                style={{
                textAlign: "center"
                }}
            >

                <div
                style={{
                    fontSize: "30px",
                    fontWeight: 700,
                    color: "#1e293b",
                    letterSpacing: "1px"
                }}
                >
                PURCHASE ORDER
                </div>

            </div>

            {/* PO NUMBER */}

            <div
                style={{
                background: "#f8fafc",
                border: "1px solid #dbeafe",
                borderRadius: "12px",
                padding: "12px",
                textAlign: "right"
                }}
            >

                <div
                style={{
                    fontSize: "11px",
                    color: "#64748b",
                    textTransform: "uppercase"
                }}
                >
                PO Number
                </div>

                <div
                style={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: "#1e293b"
                }}
                >
                {poData?.po_no}
                </div>

            </div>

            </div>
                    {/* PO + VENDOR INFORMATION */}

          <div className="row">

            {/* PO INFORMATION */}

            <div className="col-md-6">

              <div
            className="print-card"
            style={cardStyle}
            >

                <div style={sectionTitle}>
                  Purchase Order Information
                </div>

                <table className="table table-borderless table-sm mb-0">

                  <tbody>

                    <tr>
                      <th
                            width="40%"
                            style={{
                                color: "#64748b",
                                fontWeight: 600
                            }}
                            >
                        PO Number
                      </th>
                      <td>
                        {poData?.po_no}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        PO Date
                      </th>
                      <td>
                        {poData?.po_date}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Status
                      </th>
                      <td>
                        {poData?.status_name}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Currency
                      </th>
                      <td>
                        {poData?.currency}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Procurement Purpose
                      </th>
                      <td>
                        {poData?.procurement_purpose}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Delivery Date
                      </th>
                      <td>
                        {poData?.delivery_date}
                      </td>
                    </tr>

                  </tbody>

                </table>

              </div>

            </div>

             
                            
            {/* VENDOR INFORMATION */}

            <div className="col-md-6">

              <div
            className="print-card"
            style={cardStyle}
            >

                <div style={sectionTitle}>
                  Vendor Information
                </div>

                <table className="table table-borderless table-sm mb-0">

                  <tbody>

                    <tr>
                      <th width="40%">
                        Vendor Name
                      </th>
                      <td>
                        {poData?.vendor_name}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Vendor Code
                      </th>
                      <td>
                        {
                          poData?.vendor_detail?.bp_code
                        }
                      </td>
                    </tr>

                    <tr>
                      <th>
                        GST Number
                      </th>
                      <td>
                        {
                          vendorTax?.registration_no
                        }
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Contact Person
                      </th>
                      <td>
                        {
                          vendorContact?.contact_name
                        }
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Email
                      </th>
                      <td>
                        {
                          vendorContact?.email
                        }
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Mobile
                      </th>
                      <td>
                        {
                          vendorContact?.mobile
                        }
                      </td>
                    </tr>

                  </tbody>

                </table>

              </div>

            </div>

          </div>

          {/* ADDRESS */}

          <div
            className="print-card"
            style={cardStyle}
            >

            <div style={sectionTitle}>
              Vendor Address
            </div>

            <div
                        style={{
                color: "#334155",
                lineHeight: "1.8"
            }}>

              {vendorAddress?.line1}

              {vendorAddress?.line2
                ? `, ${vendorAddress.line2}`
                : ""}

              <br />

              {vendorAddress?.city}
              {vendorAddress?.state
                ? `, ${vendorAddress.state}`
                : ""}

              <br />

              {vendorAddress?.country}

              {vendorAddress?.pincode
                ? ` - ${vendorAddress.pincode}`
                : ""}

            </div>

          </div>

          {/* SHIPPING INFORMATION */}

<div
  className="print-card"
  style={cardStyle}
>

  <div style={sectionTitle}>
    Shipping / Delivery Information
  </div>

  <div className="row">

    <div className="col-md-6">

      <div
        style={{
          fontWeight: 700,
          fontSize: "16px",
          marginBottom: "10px"
        }}
      >
        Ship To
      </div>

      <div>
  {poData?.company?.company_name}
</div>

<div>
  {poData?.delivery_address_line1}
</div>

{poData?.delivery_address_line2 && (
  <div>
    {poData.delivery_address_line2}
  </div>
)}

<div>
  {poData?.delivery_city}
  {poData?.delivery_state
    ? `, ${poData.delivery_state}`
    : ""}
</div>

<div>
  {poData?.delivery_country}
  {poData?.delivery_pincode
    ? ` - ${poData.delivery_pincode}`
    : ""}
</div>

{poData?.delivery_contact_person && (
  <div>
    Contact : {poData.delivery_contact_person}
  </div>
)}

{poData?.delivery_contact_no && (
  <div>
    Mobile : {poData.delivery_contact_no}
  </div>
)}

    </div>

    <div className="col-md-6">

      <table className="table table-borderless table-sm mb-0">

        <tbody>

          <tr>
            <th width="40%">
              Delivery Date
            </th>
            <td>
              {formatDate(
                poData?.delivery_date
              )}
            </td>
          </tr>

          <tr>
            <th>
              Location Code
            </th>
            <td>
              {poData?.shipping_location?.code}
            </td>
          </tr>

        </tbody>

      </table>

    </div>

  </div>

</div>
          
          
          {/* REFERENCES */}

          <div
            className="print-card"
            style={cardStyle}
            >

            <div style={sectionTitle}>
              References
            </div>

            <div className="row">

              <div className="col-md-3">

                <strong>
                  PR Number
                </strong>

                <div>
                  {
                    traceData?.pr?.pr_no ||
                    "-"
                  }
                </div>

              </div>

              <div className="col-md-3">

                <strong>
                  RFQ Reference
                </strong>

                <div>
                  {
                    traceData?.rfq_id ||
                    "-"
                  }
                </div>

              </div>

              <div className="col-md-3">

                <strong>
                  Indent Reference
                </strong>

                <div>
                  {
                    traceData?.indent_id ||
                    "-"
                  }
                </div>

              </div>

              <div className="col-md-3">

                <strong>
                  Source Type
                </strong>

                <div>
                  {
                    poData?.source_type
                  }
                </div>

              </div>

            </div>

          </div>

          
                    {/* MATERIAL DETAILS */}

          <div
            className="print-card"
            style={cardStyle}
            >

            <div style={sectionTitle}>
              Material Details
            </div>

            <div className="table-responsive">

              <table
  className="table table-bordered"
  style={{
    marginBottom: 0,
    tableLayout: "fixed",
    fontSize: "11px"
  }}
>
  <thead
    style={{
      background: "#f8fafc",
      color: "#334155"
    }}
  >
    <tr>

      <th width="4%" style={{padding:"10px", textAlign:"center"}}>
        #
      </th>

      <th width="22%" style={{padding:"10px", textAlign:"left"}}>
        Material
      </th>

      <th width="8%" style={{padding:"10px", textAlign:"center"}}>
        HSN
      </th>

      <th width="8%" style={{padding:"10px", textAlign:"right"}}>
        Qty
      </th>

      <th width="10%" style={{padding:"10px", textAlign:"center"}}>
        UOM
      </th>

      <th width="10%" style={{padding:"10px", textAlign:"right"}}>
        Rate
      </th>

      <th width="8%" style={{padding:"10px", textAlign:"right"}}>
        Disc %
      </th>

      <th width="8%" style={{padding:"10px", textAlign:"right"}}>
        GST %
      </th>

      <th width="12%" style={{padding:"10px", textAlign:"right"}}>
        Taxable
      </th>

      <th width="12%" style={{padding:"10px", textAlign:"right"}}>
        GST
      </th>

      <th width="12%" style={{padding:"10px", textAlign:"right"}}>
        Total
      </th>

    </tr>
  </thead>

  <tbody>

    {poData?.lines?.length > 0 ? (

      poData.lines.map((line, index) => (

        <tr
          key={line.id}
          style={{
            background:
              index % 2 === 0
                ? "#ffffff"
                : "#fafafa"
          }}
        >

          <td
            style={{
              padding:"10px",
              textAlign:"center"
            }}
          >
            {index + 1}
          </td>

          <td
            style={{
              padding:"10px",
              fontWeight:600,
              color:"#1e293b",
              textAlign:"left"
            }}
          >
            {line.material_name}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"center"
            }}
          >
            {line.hsn_sac || "-"}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right"
            }}
          >
            {formatAmount(line.qty)}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"center"
            }}
          >
            {line.uom}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right"
            }}
          >
            {formatAmount(line.rate)}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right"
            }}
          >
            {line.discount_percent}%
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right"
            }}
          >
            {line.gst_rate}%
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right"
            }}
          >
            {formatAmount(line.taxable_amount)}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right"
            }}
          >
            {formatAmount(line.gst_amount)}
          </td>

          <td
            style={{
              padding:"10px",
              textAlign:"right",
              fontWeight:700,
              color:"#0f172a"
            }}
          >
            {formatAmount(line.line_total)}
          </td>

        </tr>

      ))

    ) : (

      <tr>

        <td
          colSpan="11"
          className="text-center"
        >
          No Material Found
        </td>

      </tr>

    )}

  </tbody>

</table>    

            </div>

          </div>

          {/* ADDITIONAL CHARGES */}

          {printableCharges.length > 0 && (

            <div
              style={{
                ...cardStyle,
                pageBreakInside: "avoid"
              }}
            >

              <div
                style={
                  sectionTitle
                }
              >
                Additional
                Charges
              </div>

              <table className="table table-bordered">

                <thead>

                  <tr>

                    <th>
                      Charge
                    </th>

                    <th>
                      Amount
                    </th>

                    <th>
                      GST
                    </th>

                    <th>
                      Total
                    </th>

                    <th>
                      Remarks
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {printableCharges.map(
                    charge => (

                      <tr
                        key={
                          charge.id
                        }
                      >

                        <td>
                          {
                            charge.charge_type
                          }
                        </td>

                        <td>
                          {formatAmount(
                            charge.charge_amount
                          )}
                        </td>

                        <td>
                          {formatAmount(
                            charge.gst_amount
                          )}
                        </td>

                        <td>
                          {formatAmount(
                            charge.total_amount
                          )}
                        </td>

                        <td>
                          {
                            charge.remarks
                          }
                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>

          )}

          {/* GST + TOTALS */}

          <div className="row">

            <div className="col-md-6" 
             style={{
              pageBreakInside: "avoid"
            }}>

              <div
                style={cardStyle}
              >

                <div
                  style={
                    sectionTitle
                  }
                >
                  GST Summary
                </div>

                <table className="table table-borderless table-sm mb-0">

                  <tbody>

                    <tr>

                        <th>
                        Material GST
                        </th>

                        <td
                        style={{
                            textAlign:"right"
                        }}
                        >
                        {formatAmount(
                            poData?.material_gst_amount
                        )}
                        </td>

                    </tr>

                    <tr>

                        <th>
                        Charge GST
                        </th>

                        <td
                        style={{
                            textAlign:"right"
                        }}
                        >
                        {formatAmount(
                              printableChargeGST
                          )}                        </td>

                    </tr>

                    <tr>

                        <th>
                        CGST
                        </th>

                        <td
                        style={{
                            textAlign:"right"
                        }}
                        >
                        {formatAmount(cgstTotal)}
                        </td>

                    </tr>

                    <tr>

                        <th>
                        SGST
                        </th>

                        <td
                        style={{
                            textAlign:"right"
                        }}
                        >
                        {formatAmount(sgstTotal)}
                        </td>

                    </tr>

                    <tr>

                        <th>
                        IGST
                        </th>

                        <td
                        style={{
                            textAlign:"right"
                        }}
                        >
                        {formatAmount(igstTotal)}
                        </td>

                    </tr>

                    <tr
                        style={{
                        borderTop:
                            "2px solid #dbeafe"
                        }}
                    >

                        <th>
                        Total GST
                        </th>

                        <td
                        style={{
                            textAlign:"right",
                            fontWeight:700
                        }}
                        >
                        {formatAmount(
                            printableTaxAmount
                        )}
                        </td>

                    </tr>

                    </tbody>

                </table>

              </div>

            </div>

            <div  className="col-md-6"
            style={{
              pageBreakInside: "avoid"
            }}>

              <div
                style={cardStyle}
              >

                <div
                  style={
                    sectionTitle
                  }
                >
                  Order Totals
                </div>

                <table className="table table-sm">

                  <tbody>

                    <tr>

                      <th>
                        Material Gross
                      </th>

                      <td>
                        {formatAmount(
                          poData?.material_gross_amount
                        )}
                      </td>

                    </tr>

                    <tr>

                      <th>
                        Discount
                      </th>

                      <td>
                        {formatAmount(
                          poData?.material_discount_amount
                        )}
                      </td>

                    </tr>

                    <tr>

                      <th>
                        Taxable
                      </th>

                      <td>
                        {formatAmount(
                          poData?.material_taxable_amount
                        )}
                      </td>

                    </tr>

                    <tr>

                      <th>
                        Material GST
                      </th>

                      <td>
                        {formatAmount(
                          poData?.material_gst_amount
                        )}
                      </td>

                    </tr>

                    <tr>

                      <th>
                        Charges
                      </th>

                      <td>
                        {formatAmount(
                            printableChargeAmount
                          )}
                      </td>

                    </tr>

                    <tr>

                      <th>
                        Charge GST
                      </th>

                      <td>
                        {formatAmount(
                            printableChargeGST
                          )}
                      </td>

                    </tr>

                    <tr
                      style={{
                        background:
                          "#d1fae5",
                        fontWeight:
                          700,
                        fontSize:
                          "16px"
                      }}
                    >

                      <th>
                        NET AMOUNT
                      </th>

                      <td>
                        {formatAmount(
                          printableNetAmount
                        )}
                      </td>

                    </tr>

                  </tbody>

                </table>

              </div>

            </div>

          </div>

          {/* AMOUNT IN WORDS */}

            <div
              className="print-card"
               style={{
                ...cardStyle,
                pageBreakInside: "avoid"
              }}
            >

              <div style={sectionTitle}>
                Amount In Words
              </div>

              <div
                style={{
                  padding: "14px 16px",
                  fontSize: "15px",
                  fontWeight: 500,
                  fontStyle: "italic",
                  color: "#334155",
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  lineHeight: "1.8"
                }}
              >
                {printableAmountInWords}
              </div>

            </div>
          
          {/* COMMERCIAL INFORMATION */}

          <div
            className="print-card"
            style={{
                ...cardStyle,
                pageBreakInside: "avoid"
              }}
            >

            <div style={sectionTitle}>
              Commercial Information
            </div>

            <div className="row">

              <div className="col-md-6">

                <strong>
                  Payment Terms
                </strong>

                <div
                  style={{
                    marginTop: 6,
                    whiteSpace:
                      "pre-wrap"
                  }}
                >
                  {
                    poData?.payment_terms ||
                    "-"
                  }
                </div>

              </div>

              <div className="col-md-6">

                <strong>
                  Delivery Terms
                </strong>

                <div
                  style={{
                    marginTop: 6,
                    whiteSpace:
                      "pre-wrap"
                  }}
                >
                  {
                    poData?.delivery_terms ||
                    "-"
                  }
                </div>

              </div>

            </div>

          </div>
          {/* REMARKS */}

          <div
            className="print-card"
            style={{
              ...cardStyle,
              pageBreakInside: "avoid"
            }}
            >

            <div style={sectionTitle}>
              Remarks
            </div>

            <div>
              {poData?.remarks ||
                "-"}
            </div>

          </div>

          {/* SIGNATURES */}

          <div
            className="print-card"
             style={{
              ...cardStyle,
              pageBreakInside: "avoid"
            }}
            >

            <div
              style={{
                display: "flex",
                justifyContent:
                  "space-between",
                marginTop: 80
              }}
            >

              <div
                style={{
                  textAlign:
                    "center",
                  width: "30%"
                }}
              >

                <div
                  style={{
                    borderTop:
                      "1px solid #000",
                    paddingTop: 8
                  }}
                >
                  Prepared By
                </div>

              </div>

              <div
                style={{
                  textAlign:
                    "center",
                  width: "30%"
                }}
              >

                <div
                  style={{
                    borderTop:
                      "1px solid #000",
                    paddingTop: 8
                  }}
                >
                  Checked By
                </div>

              </div>

              <div
                style={{
                  textAlign:
                    "center",
                  width: "30%"
                }}
              >

                <div
                  style={{
                    borderTop:
                      "1px solid #000",
                    paddingTop: 8
                  }}
                >
                  Approved By
                </div>

              </div>

            </div>

          </div>

        
        <div
  style={{
    textAlign: "center",
    color: "#64748b",
    fontSize: 12,
    marginTop: 20,
    paddingBottom: 20
  }}
>

  This is a system generated Purchase Order Powered by Dizypro Infotech.

</div>
        </div>

      </div>

    </>
  );

};

export default PurchaseOrderPrintDrawer;